// Interfaces
import { IFormItemContainerProps } from './interfaces'

// Antd
import { Form } from 'antd'

// Mobx
import { observer } from 'mobx-react'

const FormItemContainer = observer(
  ({ children, shouldUpdate, noStyle, commonFormItemProps, ...rest }: IFormItemContainerProps): JSX.Element => {
    return shouldUpdate ? (
      <Form.Item noStyle shouldUpdate>
        {() => {
          return (
            <Form.Item {...commonFormItemProps} noStyle={noStyle} {...rest}>
              {children}
            </Form.Item>
          )
        }}
      </Form.Item>
    ) : (
      <Form.Item {...commonFormItemProps} noStyle={noStyle} {...rest}>
        {children}
      </Form.Item>
    )
  },
)

export { FormItemContainer }
